export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      let r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
};

/** Mark items from /bundle-listings/ so cards/handlers can identify them even if listings_count is missing. */
export const markAsBundle = (item) => {
  if (!item || typeof item !== "object") return item;
  const listingsCount =
    item.listings_count ??
    (Array.isArray(item.listings) ? item.listings.length : 1);
  return {
    ...item,
    __isBundle: true,
    listings_count: listingsCount,
  };
};

export const isBundleListing = (item) => {
  if (!item || typeof item !== "object") return false;
  if (item.__isBundle) return true;
  const count = Number(item.listings_count);
  return Number.isFinite(count) && count > 0;
};

